export interface ShareLinkActions {
  /** Скопировать текст со ссылкой в буфер (`app/share.ts`); `false` — буфер недоступен. */
  copyShareLink(text: string, url: string): Promise<boolean>;
}

export const defaults: ShareLinkActions = {
  copyShareLink: async () => false,
};

declare module "../actions" {
  interface WindowActions extends ShareLinkActions {}
}
